import React, { useState, useEffect } from "react";
import { ContainerArea } from "./styled";
import faradayApi from "../../Services/faradayApi";
import { Button, Spinner } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "../Client/style.css";
import "../../Components/CoustCardRow/style.css";
import { formatCNPJ } from "../../utils/utilityFunctions";
import merxLogo from "../../Assets/merx-logo.png";
import DashboardPageLayout from "../../Components/Dashboard/DashboardPageLayout";

const ClientDashboard = () => {
  const [companyData, setCompanyData] = useState<any>();
  const [profiles, setProfiles] = useState<any[] | null>(null);
  const [userData, setUserData] = useState<any>({});

  useEffect(() => {
    const fetchData = async () => {
      const id = window.localStorage.getItem("id");
      const userResponse = await faradayApi.get(`users/${id}`);
      setUserData(userResponse?.data);

      const userCompanys = await faradayApi.get(`users/measuring-points/${id}`);
      setCompanyData(userCompanys.data);

      const measuringPoints = userCompanys.data.measuringPoints.map(
        (mp: any) => mp
      );
      setProfiles(measuringPoints);
    };
    fetchData().catch(console.error);
  }, []);

  const [show, setShow] = useState(false);
  const [name, setName] = useState(userData?.name);
  const [email, setEmail] = useState(userData?.email);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [disabled, setDisabled] = useState(false);

  const handleClose = () => setShow(false);

  const clearStates = () => {
    setPassword("");
    setConfirmPassword("");
    setEmail("");
    setDisabled(false);
  };

  const saveInfo = async () => {
    setDisabled(true);

    if (password !== confirmPassword) {
      window.alert("As duas senhas precisam ser iguais!");
      clearStates();
      handleClose();
      return;
    }

    const data = {
      password: password ? password : undefined,
      name: name ? name : undefined,
      email: email ? email : undefined,
    };

    try {
      await faradayApi.patch(`users/${userData.id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      handleClose();
      clearStates();
      window.alert("Suas novas informações foram salvas com sucesso!");
      window.location.reload();
    } catch (e) {
      window.alert(
        "Erro ao tentar salvar suas informações, por favor, verifique se os campos estão corretos!"
      );
      handleClose();
      clearStates();
    }
  };

  if (!companyData) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}
      >
        <ContainerArea>
          <Spinner
            className="text-secondary"
            animation="border"
            variant="secondary"
          />
        </ContainerArea>
      </div>
    );
  }

  return (
    <DashboardPageLayout
      title="Área do cliente"
      partnerInfoProps={{
        nome: userData?.name,
        sigla: "",
        email: userData?.email,
        cnpj: formatCNPJ(companyData?.cnpj),
        inicioLivre: companyData?.start_acl,
        logo: merxLogo,
        parterInfosTotal: [""],
      }}
      companyId={userData?.company?.id}
      cnpj={userData?.company?.cnpj}
      profiles={profiles}
      companyData={companyData}
      showCharts={!!(profiles && profiles.length > 0)}
      showMigrationMessage={false}
    >
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <strong>Edite as suas informações</strong>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "8px" }}>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Nome de exibição</Form.Label>
              <Form.Control
                type="text"
                placeholder={`${userData?.name}`}
                autoFocus
                disabled
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
              <Form.Label>E-mail</Form.Label>
              <Form.Control
                type="email"
                placeholder={`${userData?.email}`}
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput3">
              <Form.Label>Nova senha</Form.Label>
              <Form.Control
                type="password"
                placeholder="••••••"
                autoFocus
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput4">
              <Form.Label>Confirme sua nova senha</Form.Label>
              <Form.Control
                type="password"
                placeholder="••••••"
                autoFocus
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={saveInfo} disabled={disabled}>
            Salvar informações
          </Button>
        </Modal.Footer>
      </Modal>
    </DashboardPageLayout>
  );
};

export default ClientDashboard;
